var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmuteMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 30,
    fill: "none",
    stroke: "#007BFF",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "30;38;30",
    dur: "1s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0;1",
    dur: "1s",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 60c5.52 0 10-4.48 10-10V40c0-5.52-4.48-10-10-10s-10 4.48-10 10v10c0 5.52 4.48 10 10 10z",
    fill: "#007BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50v2c0 8.84-7.16 16-16 16s-16-7.16-16-16v-2h-4v2c0 10.36 7.89 18.91 18 19.88V78h-8v4h20v-4h-8v-8.12C62.11 68.91 70 60.36 70 50v-2h-4z",
    fill: "#007BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteMic);
export default __webpack_public_path__ + "static/media/unmute-mic.9c94e7c0e65d48cb9c17f117ec3377b2.svg";
export { ForwardRef as ReactComponent };